<div class="viewport-modal" role="dialog" aria-labelledby="viewport-modal-title">
  <button
    class="viewport-modal__close"
    type="button"
    aria-label="Close display tip"
    (click)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <div class="viewport-modal__header">
    <div class="viewport-modal__label">
      <mat-icon>fit_screen</mat-icon>
      <span>Display tip</span>
    </div>

    <h2 id="viewport-modal-title">More screen room needed</h2>
    <p>
      This page has wide tables and filters. If things look squeezed, use the shortcuts
      below to make the page easier to work with.
    </p>
  </div>

  <div class="viewport-modal__steps">
    <div class="viewport-modal__step">
      <mat-icon>zoom_out</mat-icon>
      <div>
        <strong>Zoom out</strong>
        <span>Press <kbd>Ctrl</kbd> + <kbd>-</kbd></span>
      </div>
    </div>

    <div class="viewport-modal__step">
      <mat-icon>zoom_in</mat-icon>
      <div>
        <strong>Zoom back in</strong>
        <span>Press <kbd>Ctrl</kbd> + <kbd>+</kbd></span>
      </div>
    </div>

    <div class="viewport-modal__step">
      <mat-icon>desktop_windows</mat-icon>
      <div>
        <strong>Recommendation</strong>
        <span>Change your screen resolution or use a larger display for the best view.</span>
      </div>
    </div>
  </div>

  <div class="viewport-modal__footer">
    <button class="viewport-modal__link-button" type="button" (click)="snoozeToday()">
      Do not show today
    </button>
    <button class="viewport-modal__primary-button" type="button" (click)="close()">
      Dismiss tip
    </button>
  </div>
</div>
